export default function customFeatureLineUp() {
  $('.featureLineupContainer').each(function () {
    const title = $(this).find('.featureLineup-title');
    let titleText = title.text().trim();
    const description =
      $(this).find('.featureLineup-text').html() == undefined
        ? ''
        : $(this).find('.featureLineup-text').html();

    const moreButton = $(this).find('.featureLineup-more');

    if (titleText.length > 45) {
      title.text(`${titleText.substring(0, 20)}...`);
      title.attr('title', titleText);
      titleText = `${titleText.substring(0, 45)}...`;
    } else {
      title.text(titleText);
    }
    $(this)
      .find('.featureLineupImage')
      .append(
        `<div class="featureLineup-description">
              <div class="content-card">
                <h4>${titleText}</h4>
                <span>${description}</span>
              </div>
            </div>`,
      );
    $(this).find('.featureLineupImage').append(moreButton);

    let imgContainer = $(this).find('.featureLineupImage');
    let headline = $(this).find('.featureLineup-headline');
    $(imgContainer).append(
      `<div class="overlay-base"><span class="card-title-base">${titleText}</span></div>`,
    );
    $(imgContainer).append(headline);
    $(this)
      .find('.featureLineupImage')
      .append(`<div class="main-title"><span class="span-title">${titleText}</span></div>`);

    $(title).remove();
    let socialContent = $(this).find('.featureLineup-buttons .featureLineup-social div').length;
    if (socialContent == 0) {
      $(this).find('.featureLineup-buttons').addClass('noSocial');
    }

    let butButton = $(this).find('.featureLineup-buynow .button').height();
    if (butButton > 22) {
      $(this).find('.featureLineup-buttons').addClass('verticalSocial');
    }
  });
}
